<template>
  <Modal class="dd-m-modal--payment">
    <LogoIcon width="32"></LogoIcon>
    <p>
      <strong>Aguarde,</strong>
      enquanto processamos
      <br />seu pagamento.
    </p>
  </Modal>
</template>

<script>
import Modal from './Modal.vue';
import LogoIcon from '../LogoIcon.vue';

export default {
  components: {
    Modal,
    LogoIcon
  }
};
</script>

<style lang="scss">
@keyframes scale {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.2);
  }
}
.dd-m-modal--payment {
  .dd-m-modal-content {
    width: 90%;
    max-width: 400px;
    padding: 32px 48px;
    border-radius: 16px;
    background-color: #fff;
    border-top: 6px solid var(--color-balanced);
    box-shadow: 0 4px 16px rgba(var(--color-black), 0.1);

    p {
      text-align: center;
      font-size: 18px;
      color: var(--color-positive-normal);
    }

    strong {
      display: block;
      font-size: 24px;
      margin-bottom: 8px;
      font-weight: 600;
    }

    .symbol {
      animation: 1s alternate infinite scale ease-out;
    }
  }
}
</style>
